import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import { LABEL_PLACEMENT } from 'baseui/checkbox'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const FillEnergyLandscape = () => {
  const {
    t,
    showEnergyLandscape: showEnergyLandscapeValue,
    isAllowedEnergyVertical,
    updateAddressesConfigHandler,
    energyLandscapeAvailable,
  } = useAddress()

  if (!isAllowedEnergyVertical || !energyLandscapeAvailable) {
    return null
  }

  return (
    <SDCheckbox
      kind='switch'
      checked={showEnergyLandscapeValue}
      onChange={value => updateAddressesConfigHandler({ showEnergyLandscape: value })}
      labelPlacement={LABEL_PLACEMENT.right}
      label={t('common:fill_energy_landscape')}
    />
  )
}

export default FillEnergyLandscape
